import { useEffect } from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import ApplicationsStrip from "../components/ApplicationsStrip";
import Problem from "../components/Problem";
import FailSafe from "../components/FailSafe";
import Engineering from "../components/Engineering";
import Compare from "../components/Compare";
import Distributor from "../components/Distributor";
import Specs from "../components/Specs";
import CTAFooter from "../components/CTAFooter";
import Brochure from "../components/Brochure";
import BrochureFab from "../components/BrochureFab";
import useReveal from "../hooks/useReveal";

export default function LandingPage() {
  useReveal();

  useEffect(() => {
    document.title = "MPS MWP1110 — Fail-Safe Switchable Coolant Pump for VW · Audi · Škoda";
  }, []);

  return (
    <>
      <div className="site-root min-h-screen bg-white text-white selection:bg-[#5B9BD5] selection:text-black">
        <Header />
        <main>
          <Hero />
          <ApplicationsStrip />
          <Problem />
          <FailSafe />
          <Engineering />
          <Compare />
          <Distributor />
          <Specs />
          <CTAFooter />
        </main>
      </div>

      {/* Print-only PDF brochure + screen-only export button */}
      <Brochure />
      <BrochureFab />
    </>
  );
}
